<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <AddNewProduct
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />
    <!-- <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" search :data="products">-->
    <vs-table
      ref="table"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="getProducts"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ACTION - DROPDOWN -->
          <!--
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Another Action</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>-->

          <!-- ADD NEW -->
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNewData"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Novo</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ getProducts.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : getProducts.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=200">
              <span>200</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=300">
              <span>300</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=400">
              <span>400</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Foto</vs-th>
        <vs-th sort-key="name">Nome</vs-th>
        <vs-th sort-key="code">Código</vs-th>
        <vs-th sort-key="category">Categoria</vs-th>
        <vs-th>Editar</vs-th>
        <vs-th>Modificado Por</vs-th>
        <vs-th>Remover</vs-th>
   
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="product" :key="indextr" v-for="(product, indextr) in data">
            <vs-td class="img-container">
            <div v-lazy-container="{ selector: 'img' }">
                <img
                  key="onlineImg"
                  v-bind:data-src="product.photoProduct" 
                  alt="product-img"
                  width="100"
                  height="100"
                  class="product-img rounded-none shadow-md cursor-pointer block"
                 
                />
            </div>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ product.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ product.code }}</p>
            </vs-td>
            <vs-td v-if="product.category == 'EQUIPAMENTOS'">
                <vs-chip color="success">{{product.category}}</vs-chip>
            </vs-td>
             <vs-td v-if="product.category == 'SUPRIMENTOS'">
                <vs-chip color="warning">{{product.category}}</vs-chip>
            </vs-td>
              <vs-td v-if="product.category == 'PEÇAS'">
                <vs-chip color="primary">{{product.category}}</vs-chip>
            </vs-td>
              <vs-td v-if="product.category == 'SERVIÇOS'">
                <vs-chip color="dark">{{product.category}}</vs-chip>
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(product)"
              />
            </vs-td>   
            <vs-td>
               <vx-tooltip :text="product.userName" position="left">
              <vs-avatar
                :src="product.photo"
                size="30px"
                class="border-2 border-white border-solid -m-1"
              ></vs-avatar>
               </vx-tooltip>
            </vs-td>
            <vs-td>
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteData(product.idProduct, product.photoProduct)"
              />
            </vs-td>
         
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>
 
<script>
import AddNewProduct from "./AddNewProduct.vue";


export default {
  components: {
    AddNewProduct
  }, 
  data() {
    return {
      selected: [],
      products: [],
      itemsPerPage: 100,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      activeAlert: false
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.getProducts.length;
    },
     getProducts() {
      return this.$store.state.products;
    },
    /*
    getProducts() {
      let products = _.cloneDeep(this.$store.state.products)
      products.forEach((el) => delete el.photoProduct);
      return products;
    },
    getPhotos() {
      const photos = this.$store.state.products.map((el) => el.photoProduct);
      return photos; 
    },*/
  },
  methods: {
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    async deleteData(idProduct, photoProduct) {
      let payload = {
          idProduct: idProduct,
          photoProduct: photoProduct,
          notify: this.$vs.notify
        } 
        this.$store.dispatch('removeProduct', payload)
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getOrderStatusColor(status) {
      if (status == "on_hold") return "warning";
      if (status == "delivered") return "success";
      if (status == "canceled") return "danger";
      return "primary";
    },
    getPopularityColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    }
  },
 async created() {
   let payload = {
       loading : this.$vs.loading
     }
    
     await this.$store.dispatch("fetchProductsItems",payload)
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
